// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"question-and-answer_wrapper__cDN_e","content":"question-and-answer_content__FlunN"};